<template>
  <div id="app">
    <LoadingScreen :isLoading="isLoading" />
    <router-view v-if="contentVisible" />
  </div>
</template>

<script>
import { WOW } from "wowjs";
import LoadingScreen from "@/components/LoadingScreen.vue";

export default {
  components: {
    LoadingScreen,
  },
  data() {
    return {
      isLoading: true,
      contentVisible: false,
    };
  },
  mounted() {
    // Detect if user agent is a bot or prerender service
    const isBot =
      /googlebot|bingbot|duckduckbot|slurp|facebookexternalhit|linkedinbot|twitterbot|bot|crawl|spider|mediapartners-google/i.test(
        navigator.userAgent
      );
    const isPreRender = /prerender|page-replica/i.test(navigator.userAgent);

    // if user agent is a bot or prerender service, skip loading screen
    if (isBot || isPreRender) {
      this.isLoading = false;
      this.contentVisible = true;
      window.onload = () => {
        this.addCustomAnimations();
      };
      return;
    }

    // Prevent scrolling while loading
    document.body.style.overflow = "hidden";

    // Handle window load and fallback
    if (document.readyState === "complete") {
      this.finishLoading();
    } else {
      window.addEventListener("load", () => {
        this.finishLoading();
      });
    }

    // Fallback in case window load event takes too long
    setTimeout(() => {
      if (this.isLoading) {
        this.finishLoading();
      }
    }, 3500);
  },
  methods: {
    finishLoading() {
      // remove fbclid from url when visiting from facebook
      if (/^\?fbclid=/.test(location.search))
        location.replace(location.href.replace(/\?fbclid.+/, ""));

      // if content is already visible and loading is false, skip
      if (this.contentVisible && !this.isLoading) return;

      this.contentVisible = true;

      // Wait for Vue to render the router-view content
      this.$nextTick(() => {
        // set timeout to 1 second
        setTimeout(() => {
          this.addCustomAnimations(); // add custom animations
          this.initializeWOW(); // initialize WOW.js

          this.isLoading = false; //reset loading state
          document.body.style.overflow = "auto"; // allow scrolling
        }, 1000);
      });
    },
    initializeWOW() {
      // Initialize WOW.js with the correct base class for Animate.css v4
      const wow = new WOW({
        boxClass: "wow",
        animateClass: "animate__animated", // Changed from "animated" for Animate.css v4 compatibility
        offset: 250,
        mobile: true,
        live: false,
      });
      wow.init();
    },
    addCustomAnimations() {
      // add animation to header section
      const headerHeader = document.querySelector(".header-header");
      if (headerHeader) {
        headerHeader.classList.add("header-header-load-animation");
      }

      // add animation to profile image
      const profile = document.querySelector(".profile");
      if (profile) {
        profile.classList.add("profile-load-animation");
      }
    },
  },
};
</script>
